import React, { useState, useEffect } from 'react';
import { getDashboardStatistics } from '../../utils/apiHelper';
import { formatPrice } from '../../utils/formatHelper';
import InfoTooltip from './InfoTooltip';

const TopProducts = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await getDashboardStatistics.products();
        if (res?.success) setData(res.statistics);
      } catch (err) {
        console.error('Top products error:', err);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const products = data?.topProducts || [];

  return (
    <div className="detail-panel">
      <div className="detail-panel-header">
        <div className="detail-panel-title">
          <i className="fas fa-trophy me-2" style={{ color: '#f59e0b' }}></i>
          En Çok Satan Ürünler
          <InfoTooltip text="Teslim edilen siparişlerdeki ürünlerin sipariş sayısına göre sıralaması (tüm zamanlar)." />
        </div>
      </div>
      <div className="detail-panel-body" style={{ padding: 0 }}>
        {loading ? (
          <div className="section-loading"><div className="spinner-border spinner-border-sm" role="status"></div></div>
        ) : products.length === 0 ? (
          <div className="py-4 text-center text-muted small">Henüz veri yok</div>
        ) : (
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Ürün</th>
                <th>Sipariş</th>
                <th>Adet</th>
                <th>Gelir</th>
              </tr>
            </thead>
            <tbody>
              {products.map((p, i) => (
                <tr key={p.id}>
                  <td className="fw-bold text-muted">{i + 1}</td>
                  <td className="text-truncate" style={{ maxWidth: '150px' }}>{p.name}</td>
                  <td>{p.orderCount}</td>
                  <td>{p.totalQuantity}</td>
                  <td>{formatPrice(p.totalRevenue)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default TopProducts;
